export default __webpack_public_path__ + "static/media/goopter-app.d26dbbf3.svg";